import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/store/store";
import { ROUTES } from "../App/routePaths";

const PublicRoute = ({ children }) => {
  const sessionToken = useAppSelector((state) => state.sessionToken);

  if (sessionToken) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return children;
};

export default PublicRoute;
